$(document).ready(function () {

    /********** Registration Form *************/
    const registerForm = $('#register-form');
    registerForm.validate({
        ignore: [],
        rules: {
            field: {
                required: true
            },
            first_name: {
                normalizer: function(value) {
                    return $.trim(value);
                },
                minlength: 3
            },
            last_name: {
                normalizer: function(value) {
                    return $.trim(value);
                },
                minlength: 1
            },
            email: {
                normalizer: function(value) {
                    return $.trim(value);
                },
                email: true
            },
            phone: {
                normalizer: function(value) {
                    return $.trim(value);
                },
                minlength: 6
            },
            company_name: {
                normalizer: function(value) {
                    return $.trim(value);
                },
                minlength: 1
            },
            company_activity: {
                normalizer: function(value) {
                    return $.trim(value);
                },
                minlength: 1
            },
            password: {
                normalizer: function(value) {
                    return $.trim(value);
                },
                minlength: 6
            },
            confirm_password: {
                normalizer: function(value) {
                    return $.trim(value);
                },
                minlength: 6,
                equalTo: "#password"
            },
        }
    });

    /********** Login Form *************/
    const loginForm = $('#login-form');
    loginForm.validate({
        ignore: [],
        rules: {
            field: {
                required: true
            },
            email: {
                normalizer: function(value) {
                    return $.trim(value);
                },
                email: true
            },
            password: {
                normalizer: function(value) {
                    return $.trim(value);
                },
                minlength: 6
            },
        }
    });




    /********** Contact Property Form *************/
    const contactPropertyForm = $('#offer-contact-form');
    contactPropertyForm.validate({
        ignore: [],
        rules: {
            field: {
                required: true
            },
            phone: {
                normalizer: function(value) {
                    return $.trim(value);
                },
                minlength: 1
            },
            email: {
                normalizer: function(value) {
                    return $.trim(value);
                },
                email: true
            },
            message: {
                normalizer: function(value) {
                    return $.trim(value);
                },
                minlength: 10
            },
            'g-recaptcha-response': {
                required: true
            }
        }
    });

    $('.reset-password').validate({
        ignore: [],
        rules: {
            field: {
                required: true
            },
            email: {
                email: true
            },
            'g-recaptcha-response': {
                required: true
            }
        }
    });

    $('#reset-pass-email-form').validate({
        ignore: [],
        rules: {
            field: {
                required: true
            },
            email: {
                email: true
            },
            password_confirmation: {
              equalTo: '#password'
            },
            'g-recaptcha-response': {
                required: true
            }
        }
    });


    /********** Contacts Form *************/
    const contactsForm = $("#contacts-form");
    contactsForm.validate({
        ignore: [],
        rules: {
            field: {
                required: true
            },
            contacts_name: {
                normalizer: function(value) {
                    return $.trim(value);
                },
                minlength: 3
            },
            contacts_email: {
                normalizer: function(value) {
                    return $.trim(value);
                },
                email: true
            },
            contacts_message: {
                normalizer: function(value) {
                    return $.trim(value);
                },
                minlength: 6
            },
            'g-recaptcha-response': {
                required: true
            }
        }
    });
});